export enum TemplateCanvasActionType {
  Add,
  Remove,
}
